import React from 'react';

export function BusyPage() {

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>BALLOT REGISTRATION</h2>
                    <h2>抽籤登記</h2>
                </div>
            </div>
            <p className="text-center">
                Server is busy, please try again later.
            </p>
            <p className="text-center">
                網站系統現正繁忙，請稍後重試
            </p>
        </div>
    );
}
